<template>
  <v-app
    class="tw-bg-gray-300 tw-w-full tw-relative tw-overflow-hidden"
    :class="checkBlackListed ? 'tw-hidden' : ''"
    dark
  >
    <v-main
      :class="layout_smartbio !== 2 ? 'gradient' : null"
      :style="{
        background: `url(${
          pageOptions && pageOptions.useSpotifyCanvas
            ? artistImageSpotify
            : pageOptions && (pageOptions.background || artistImageSpotify)
        }`,
        backgroundPosition: 'top center',
        backgroundRepeat: 'no-repeat'
      }"
      class="tw-w-full tw-h-full tw-fixed tw-left-0 tw-top-0 tw-bg-cover"
    >
      <video
        v-if="
          pageOptions &&
            (pageOptions.useSpotifyCanvas == false &&
              artist.artista_premium === true)
        "
        :src="pageOptions ? pageOptions.background : null"
        autoplay
        class="full"
        loop
        muted
        playsinline
      />
    </v-main>
    <v-main class="tw-relative tw-w-full">
      <div
        :class="layout_smartbio === 3 ? 'sm:tw-pt-0' : 'sm:tw-py-10'"
        class="tw-flex tw-h-full tw-justify-center tw-z-10 tw-p-0"
      >
        <div
          class="tw-w-full sm:tw-max-w-md lg:tw-max-w-xl xl:tw-max-w-2xl tw-mx-auto"
        >
          <div
            :class="layout_smartbio === 2 && 'glass sm:tw-h-auto'"
            class="tw-h-full tw-py-8 tw-px-5 tw-mx-2 tw-overflow-hidden tw-relative"
          >
            <section
              id="bio"
              :class="{
                'lg:tw-pt-48 sm:tw-pt-24 tw-pt-32': layout_smartbio === 3
              }"
              class="tw-flex tw-flex-col tw-break-all tw-items-center tw-relative tw-mb-12"
            >
              <v-avatar v-if="layout_smartbio === 1" size="120">
                <img
                  :src="
                    avatar_url.length > 23
                      ? avatar_url
                      : artistImageSpotify || imageDefault
                  "
                  alt="John"
                />
              </v-avatar>
              <h1
                :style="textColor ? `color: ${textColor}` : ''"
                class="tw-w-full tw-text-center tw-font-sans tw-font-extrabold tw-mt-5 md:tw-text-4xl tw-text-2xl tw-uppercase"
              >
                {{ title }} 
              </h1>
              <h4
                :style="textColor ? `color: ${textColor}` : ''"
                class="tw-w-full tw-text-center tw-font-sans tw-text-lg"
              >
                {{ description }}
              </h4>
            </section>
            <section
              v-for="link in links"
              id="links"
              :key="link.order"
              class="tw-mt-3 tw-relative"
            >
              <v-btn
                v-if="link.type === 'primary'"
                :color="bgColor"
                :href="'/s/bio/' + link.id"
                :style="{
                  borderColor: color,
                  color
                }"
                block
                class="tw-shadow-2xl tw-rounded-xl tw-mb-1 tw-border-4 tw-border-solid"
                :class="isNotUpperCase && 'uppercase-none'"
                depressed
                height="auto"
                large
                link
                tag="a"
                target="_blank"
              >
                <span
                  class="tw-font-extrabold text-wrap tw-w-10/12 tw-text-center"
                >
                  {{ link.label }}
                </span>
              </v-btn>
              <v-btn
                v-if="link.type === 'secondary'"
                :color="color"
                :href="'/s/bio/' + link.id"
                :style="{
                  borderColor: bgColor,
                  color: bgColor
                }"
                block
                class="tw-shadow-2xl tw-rounded-xl tw-border-2"
                :class="isNotUpperCase && 'uppercase-none'"
                depressed
                height="auto"
                large
                link
                tag="a"
                target="_blank"
              >
                <span
                  class="tw-font-extrabold text-wrap tw-w-10/12 tw-text-center"
                >
                  {{ link.label }}
                </span>
              </v-btn>
              <v-btn
                v-if="link.type === 'simple'"
                :color="color"
                :href="'/s/bio/' + link.id"
                :style="`color: ${bgColor}`"
                block
                class="tw-text-normal textTransform tw-shadow-sm tw-rounded-xl tw-mb-1 tw-border tw-border-gray-500 tw-border-opacity-10"
                :class="isNotUpperCase && 'uppercase-none'"
                dark
                height="auto"
                large
                link
                tag="a"
                target="_blank"
              >
                <span
                  class="tw-font-extrabold text-wrap tw-w-10/12 tw-text-center"
                >
                  {{ link.label }}
                </span>
              </v-btn>
              <v-img
                v-if="link.type === 'featured'"
                :aspect-ratio="31 / 10"
                :gradient="
                  `to right top, ${setAlpha(bgColor)} 35%, ${setAlpha(color)}`
                "
                :src="link.cover_url"
                class="tw-rounded-xl"
                width="100%"
              >
                <div
                  class="tw-w-10/12 tw-flex tw-items-center tw-justify-center tw-h-full tw-mx-auto"
                >
                  <v-btn
                    :color="color"
                    :href="'/s/bio/' + link.id"
                    block
                    class="tw-mx-4 glass"
                    :class="isNotUpperCase && 'uppercase-none'"
                    dark
                    depressed
                    height="auto"
                    large
                    link
                    outlined
                    rounded
                    target="_blank"
                    width="80%"
                  >
                    <span
                      class="tw-font-extrabold text-wrap tw-w-10/12 tw-text-center"
                    >
                      {{ link.label }}
                    </span>
                  </v-btn>
                </div>
              </v-img>
            </section>
            <section
              v-if="haveSocialLinks"
              id="social"
              class="tw-flex tw-mt-8 tw-items-center tw-w-full tw-justify-center tw-gap-10 tw-pt-5 tw-relative"
            >
              <a
                v-if="social_links.youtube"
                :href="'https://youtube.com/channel/' + social_links.youtube"
                target="_blank"
              >
                <v-icon :color="socialColor" class="tw-text-2xl">
                  mdi-youtube
                </v-icon>
              </a>
              <a
                v-if="social_links.twitter"
                :href="social_links.twitter"
                target="_blank"
              >
                <v-icon :color="socialColor" class="tw-text-2xl">
                  mdi-twitter
                </v-icon>
              </a>
              <a
                v-if="social_links.instagram"
                :href="social_links.instagram"
                target="_blank"
              >
                <v-icon :color="socialColor" class="tw-text-2xl">
                  mdi-instagram
                </v-icon>
              </a>
              <a
                v-if="social_links.tiktok"
                :href="social_links.tiktok"
                target="_blank"
              >
                <v-icon :color="socialColor" class="tw-text-2xl">
                  fab fa-tiktok
                </v-icon>
              </a>
              <a
                v-if="social_links.facebook"
                :href="social_links.facebook"
                target="_blank"
              >
                <v-icon :color="socialColor" class="tw-text-2xl">
                  mdi-facebook
                </v-icon>
              </a>
              <a
                v-if="social_links.email"
                :href="'mailto:' + social_links.email"
                target="_blank"
              >
                <v-icon :color="socialColor" class="tw-text-2xl">
                  mdi-email
                </v-icon>
              </a>
            </section>
            <div class="tw-mx-auto tw-my-8 tw-relative">
              <a href="https://musicpro.live/" target="_blank">
                <img
                  alt="logo"
                  class="tw-w-32 tw-mx-auto musicpro-logo"
                  src="/imgs/musicpro-logo.png"
                />
              </a>
            </div>
            <template>
              <v-row justify="center">
                <v-dialog v-model="dialog" persistent width="1024">
                  <template v-slot:activator="{ props }">
                    <v-btn x-small v-bind="props" @click="dialog = true">
                      Denuncie
                    </v-btn>
                  </template>
                  <v-card>
                    <v-form
                      ref="form"
                      v-model="valid"
                      lazy-validation
                      @submit.prevent="handleSubmit()"
                    >
                      <v-card-title>
                        <span class="text-h5"
                          >Nos ajude com a sua denúncia</span
                        >
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <v-row>
                            <!-- name -->
                            <v-col cols="12" sm="6">
                              <v-text-field
                                label="Deseja informar seu nome? Por favor, digite aqui..."
                                name="name"
                                v-model="complaintPost.name"
                                maxlength="100"
                              ></v-text-field>
                            </v-col>

                            <!-- email -->
                            <v-col cols="12" sm="6">
                              <v-text-field
                                label="Email"
                                name="email"
                                maxlength="250"
                                v-model="complaintPost.email"
                                hint="Caso queira que nossa equipe entre em contato, informe seu e-mail"
                              ></v-text-field>
                            </v-col>

                            <!-- text -->
                            <v-col cols="12">
                              <v-text-field
                                maxlength="250"
                                label="Descreva sua denúncia..."
                                name="text"
                                v-model="complaintPost.text"
                                hint="Ex: Conteúdo impróprio"
                                persistent-hint
                                required
                                :rules="nameRules"
                              ></v-text-field>
                            </v-col>

                            <!-- Type -->
                            <v-col cols="12" sm="6">
                              <v-select
                                :items="[
                                  'leve',
                                  'médio',
                                  'grave',
                                  'gravíssimo'
                                ]"
                                maxlength="250"
                                label="Grau"
                                v-model="complaintPost.type"
                                name="type"
                                required
                                :rules="nameRules"
                              ></v-select>
                            </v-col>

                            <!-- Reason -->
                            <v-col cols="12" sm="6">
                              <v-autocomplete
                                :items="[
                                  'Conteúdo impróprio',
                                  'Violência',
                                  'Plágio',
                                  'Outros'
                                ]"
                                maxlength="250"
                                label="Motivo"
                                v-model="complaintPost.reason"
                                name="reason"
                                required
                                :rules="nameRules"
                                multiple
                              ></v-autocomplete>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="blue-darken-1"
                          variant="text"
                          @click="dialog = false"
                        >
                          Fechar
                        </v-btn>
                        <v-btn
                          :disabled="!valid"
                          color="blue-darken-1"
                          variant="text"
                          type="submit"
                        >
                          Enviar
                        </v-btn>
                      </v-card-actions>
                    </v-form>
                  </v-card>
                </v-dialog>
              </v-row>
            </template>
          </div>
        </div>
        <v-snackbar v-model="snackbar">
          {{ snackbarText }}

          <template v-slot:action="{ attrs }">
            <v-btn color="purple" text v-bind="attrs" @click="snackbar = false">
              Fechar
            </v-btn>
          </template>
        </v-snackbar>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import Layout from "@/Shared/NoMenu";

let Vibrant = require("node-vibrant");
let tinycolor = require("tinycolor2");

export default {
  layout: (h, page) => h(Layout, [page]),
  layout: Layout,
  props: [
    "id_smartbio",
    "slug",
    "artist",
    "artist_name",
    "title",
    "description",
    "avatar_url",
    "social_links",
    "is_active",
    "links",
    "layout_smartbio",
    "singleSpotifyImage",
    "spotifyArtist",
    "pageOptions",
    "complaint",
    "blacklist",
    "smartbio",
    "auth",
    "isNotUpperCase"
  ],
  data() {
    return {
      bgColor: "",
      beatmakerAvatar:
        "https://firebasestorage.googleapis.com/v0/b/brartist-c47d3.appspot.com/o/images%2Fartistas%2FU6COOGoa1w4RfjwfzRDZ.jpg?alt=media&token=4a994ac2-6b62-4ae0-9aa0-431fe9e6b163",
      image: "",
      imageDefault:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/User-avatar.svg/1200px-User-avatar.svg.png",
      artistImageSpotify: "",
      color: "",
      textColor: "",
      video: "",
      snackbar: false,
      snacktext: "",
      complaintPost: {
        name: "",
        text: "",
        email: "",
        type: "",
        reason: ""
      },
      nameRules: [v => !!v || "Campo requerido"],
      dialog: false,
      valid: true,
      checkBlackListed: false
    };
  },
  computed: {
    socialColor() {
      if (this.layout_smartbio === 2 && this.color) {
        return this.color;
      }
      return "#222";
    },
    haveSocialLinks() {
      let keys = Object.keys(this.social_links);
      if (!keys.length) return false;
      let keysWithText = keys.filter(key => !!this.social_links[key]);
      return keysWithText.length;
    }
  },
  methods: {
    getSmartbioLinks(smartbio) {
      const { links } = JSON.parse(JSON.stringify(smartbio));
      const dataSmartbioLinks = Object.values(links);
      const [urls, labels] = dataSmartbioLinks.map(({ url, label }) => [
        url,
        label
      ]);
      return [urls, labels];
    },
    getSmartbioData(smartbio) {
      const dataSmartbio = Object.entries(JSON.parse(JSON.stringify(smartbio)));
      return dataSmartbio;
    },
    checkBlackList() {
      const dataSmartbio = this.getSmartbioData(this.smartbio);
      const dataSmartbioLinks = this.getSmartbioLinks(this.smartbio);

      let blacklist = this.blacklist;

      function isBlacklisted(dataSmartbio, dataSmartbioLinks, blacklist) {
        const smartbioItems = dataSmartbio
          .map(item => {
            if (typeof item[1] === "string") {
              return item[1].toLowerCase();
            }
            return "";
          })
          .filter(item => item !== "");
        if (smartbioItems.some(item => blacklist.includes(item))) {
          return true;
        }

        const smartbioLinksUrl = dataSmartbioLinks[0]?.map(item =>
          item
            .match(/\b(\w|')+\b/gim)
            .join("")
            .toLowerCase()
        );
        const smartbioLinksLabel = dataSmartbioLinks[1]?.map(item =>
          item
            .match(/\b(\w|')+\b/gim)
            .join("")
            .toLowerCase()
        );
        if (
          smartbioLinksUrl?.some(item => blacklist.includes(item)) ||
          smartbioLinksLabel?.some(item => blacklist.includes(item))
        ) {
          return true;
        }

        return false;
      }

      let isBlackList = isBlacklisted(
        dataSmartbio,
        dataSmartbioLinks,
        blacklist
      );

      return isBlackList;
    },
    async handleSubmit() {
      let data = {
        fk_smartbio_id: this.id_smartbio,
        smartbio_slug: this.slug,
        created_at: new Date(),
        name: this.complaintPost.name || "Anônimo",
        text: this.complaintPost.text || "",
        email: this.complaintPost.email || "",
        type: this.complaintPost.type || "",
        reason: this.complaintPost.reason || ""
      };

      if (this.$refs.form.validate()) {
        try {
          await axios.post("/api/complaint", data);

          this.snackbarText = "Agradecemos seu feedback";
          this.snackbar = true;
          this.dialog = false;
        } catch {
          console.log(error);

          this.snackbarText = "Erro ao enviar feedback!";
          this.snackbar = true;
        }
      }
    },
    async setSmartbioBlocked(boolean) {
      if (boolean) {
        let data = {
          title: this.smartbio.title,
          description: this.smartbio.description,
          smartbio_slug: this.slug,
          artista_id: this.smartbio.artist_id,
          created_at: new Date(),
          fk_smartbio_id: this.id_smartbio
        };

        try {
          await axios.post("/api/smartbio-blocked", data);
          await axios.patch(
            `${process.env.MIX_DASHBOARD_API_BASE}/smartbio/${this.id_smartbio}`,
            {
              is_active: false
            },
            {
              headers: {
                Authorization: `Bearer ${this.auth}`
              }
            }
          );
        } catch (error) {
          console.log(error);
        }
      }
    },

    setAlpha(color, opacity = 0.4) {
      return tinycolor(color)
        .setAlpha(opacity)
        .toRgbString();
    },
    isLight(color) {
      return tinycolor(color).isLight();
    },
    betterColor(color, options = [this.color, this.bgColor]) {
      return tinycolor.mostReadable(color, options).toHexString();
    },
    getColor() {
      let vm = this;
      if (vm.pageOptions && vm.pageOptions.mainColor) {
        return (vm.color = vm.pageOptions.mainColor);
      }

      function arredonda(v) {
        return 5 * Math.round(v / 5);
      }

      function componentToHex(c) {
        let hex = c.toString(16);
        return hex.length === 1 ? "0" + hex : hex;
      }

      function rgbToHex(r, g, b) {
        return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
      }

      let img = new Image();
      img.src = this.artistImageSpotify;
      img.crossOrigin = "Anonymous";
      img.onload = function() {
        let canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        let context = canvas.getContext("2d");

        context.drawImage(img, 0, 0);

        let map = context.getImageData(0, 0, img.width, img.height).data;

        let hex, r, g, b;
        let histograma = {};
        for (let i = 0, len = map.length; i < len; i += 4) {
          r = arredonda(map[i]);
          g = arredonda(map[i + 1]);
          b = arredonda(map[i + 2]);

          hex = rgbToHex(r, g, b);

          if (histograma[hex] === undefined) {
            histograma[hex] = 1;
          } else {
            histograma[hex]++;
          }
        }

        let corMaisComum = null;
        let frequenciaCorMaisComum = 0;
        for (let cor in histograma) {
          if (frequenciaCorMaisComum < histograma[cor]) {
            corMaisComum = cor;
            frequenciaCorMaisComum = histograma[cor];
          }
        }

        vm.color = corMaisComum;
      };
    }
  },
  created: function() {
    Vibrant.from(this.beatmakerAvatar).getPalette((err, palette) => {
      if (this.pageOptions && this.pageOptions.backgroundColor) {
        this.bgColor = this.pageOptions.backgroundColor;
      } else {
        this.bgColor = palette.Vibrant.hex;
      }
    });
  },
  mounted() {
    this.checkBlackList();
    this.checkBlackListed = this.checkBlackList();
    this.setSmartbioBlocked(this.checkBlackListed);

    if (this.pageOptions) {
      this.textColor = this.pageOptions.textColor;

      if (this.pageOptions.mainColor) {
        this.getColor();
      }

      if (this.pageOptions.background) {
        let videoUrl = JSON.stringify(this.pageOptions.background);
        this.video = JSON.parse(videoUrl);
      }
    }

    if (this.singleSpotifyImage && this.singleSpotifyImage.length) {
      let imageUrl = this.singleSpotifyImage.length
        ? JSON.stringify(this.singleSpotifyImage[0].images[0].url)
        : null;
      this.image = JSON.parse(imageUrl);
    }

    if (
      this.spotifyArtist &&
      this.spotifyArtist.images &&
      this.spotifyArtist.images.length
    ) {
      let artistImageSpotifyUrl = JSON.stringify(
        this.spotifyArtist.images[0].url
      );
      this.artistImageSpotify = JSON.parse(artistImageSpotifyUrl);
    }
  }
};
</script>
<style>
.v-btn__content {
  flex: none !important;
  width: 100%;
}
.uppercase-none {
  text-transform: none !important;
}
</style>
<style scoped>
.avatar-pic {
  position: absolute;
  top: 0;
  left: 0;
  width: calc(100% - 10px);
  margin: 0 5px;
  mask-image: linear-gradient(
    180deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 1) 80%,
    rgba(255, 255, 255, 0) 100%
  );
}

.gradient::after {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  margin: 0;
  background-image: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.1) 60%,
    rgba(255, 255, 255, 1) 90%,
    rgba(255, 255, 255, 1) 100%
  );
  transition: background-color 0.2s ease-in-out;
  content: "";
}

.gradient_layout_3 {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  margin: 0;
}

.gradient_layout_3::after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  content: "";
  background-image: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0) 80%,
    rgba(255, 255, 255, 1) 90%,
    rgba(255, 255, 255, 1) 100%
  );
}

.full {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.glass {
  background: rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  -webkit-box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(4.4px);
  -webkit-backdrop-filter: blur(4.4px);
}

.v-size--large {
  padding: 30px 0 !important;
}

.v-size--large {
  padding: 25px 50px !important;
}

.blur {
  filter: blur(16px) !important;
}

@media (max-width: 720px) {
  .v-size--large {
    padding: 15px 0 !important;
  }

  .v-size--large {
    padding: 15px 30px !important;
  }
}
</style>
